import ReportComponent from "./components/ReportComponent";

const Report = () => {
  return <ReportComponent />;
};

export default Report;
